import { createApiSlice } from 'app/createApiSlice'
import {
  API_WAREHOUSE,
  API_WAREHOUSE_ITEMS,
  API_WAREHOUSE_NETWORK_SUMMARY_V2,
  API_WAREHOUSE_SUMMARY,
} from 'utils/apiList'

export const warehouseSummaryApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'warehouseSummary/api',
  endpoints(builder) {
    return {
      fetchWarehouseById: builder.query({
        query({ id }) {
          if (!id) {
            throw new Error("Parameter 'warehouseId' is mandatory!.")
          }
          return {
            url: API_WAREHOUSE,
            params: {
              id,
            },
          }
        },
      }),
      fetchWarehouseSummary: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'total',
          sortdir = 'asc',
          warehouseId,
          month,
          type = 'current',
          groupId,
          from,
          to,
          all,
          s,
          itemIds
        }) {
          return {
            url: API_WAREHOUSE_SUMMARY,
            params: {
              page,
              size,
              sortby,
              sortdir,
              warehouseId,
              month,
              type,
              s,
              ...(groupId ? { groupId } : {}),
              ...(from ? { from } : {}),
              ...(to ? { to } : {}),
              ...(all ? { all } : {}),
              ...(itemIds ? { itemIds } : {}),
            },
          }
        },
      }),
      fetchWarehouseSummaryV2: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'total',
          sortdir = 'asc',
          warehouseId,
          month,
          type = 'current',
          groupId,
          date,
          s,
          itemIds
        }) {
          return {
            url: API_WAREHOUSE_NETWORK_SUMMARY_V2,
            params: {
              page,
              size,
              sortby,
              sortdir,
              warehouseId,
              month,
              type,
              s,
              ...(groupId ? { groupId } : {}),
              ...(date ? { date } : {}),
              ...(itemIds ? { itemIds } : {}),
            },
          }
        },
      }),

      fetchWarehouseItems: builder.query({
        query({
          page = 0,
          size = 10,
          warehouseId,
          startdate,
          enddate
        }) {
          return {
            url: API_WAREHOUSE_ITEMS,
            params: {
              page,
              size,
              warehouseId,
              startdate,
              enddate,
            },
          }
        },
      }),
    }
  },
})

export const {
  useFetchWarehouseByIdQuery,
  useFetchWarehouseSummaryQuery,
  useLazyFetchWarehouseSummaryQuery,
  useFetchWarehouseSummaryV2Query,
  useLazyFetchWarehouseSummaryV2Query,
  useFetchWarehouseItemsQuery,
  useLazyFetchWarehouseItemsQuery,
} = warehouseSummaryApiSlice

